// AKA Base Solution
// Version 1.0
//
// Authors: Vinicius Artioli, Catia Melo, Sam Johnson, Aung Myo Win, Tony Possamai, Chris Muldoon

import "../scss/styles.scss";

const $ = window.jQuery;

// import "../slick/slick";

import 'bootstrap';
import '@popperjs/core';
import "popper.js";

// LIBRARY
import "./libs/minimusic";

// COMMON
import "./common/header";
import "./common/geo-targeting";
import "./common/site-modal";

// BLOCKS
import "./blocks/block-cast-and-creative";
import "./blocks/block-carousel-and-text";
import "./blocks/block-cards-image";
import "./blocks/block-cards-news";
import "./blocks/block-text-and-thumbnails";
import "./blocks/block-gallery-global";
import "./blocks/block-gallery-horizontal";
import "./blocks/block-gallery-scroller";
import "./blocks/block-hero-carousel-global";
import "./blocks/block-faq-tabs";
import "./blocks/block-fixed-banner";
import "./blocks/block-hero-video";
import "./blocks/block-info-image-cards";
import "./blocks/block-audio";
import "./blocks/block-text-slider";
import "./blocks/block-ticket-calendar";
import "./blocks/block-quote-slider";

// import "./blocks/block-quote-slider";

$(function () {
	$("body").removeClass("loading");

	$(".country-select").on("click", function (e) {
		$(this).toggleClass("drop");
	});

	$(".spotify-wrap > .btn-listen").on("click", function (e) {
		e.preventDefault();
		if ($("#spotify-embed").length > 0) {
			var spotify_embed = $("#spotify-embed").html();
			$("#spotify-embed").replaceWith(spotify_embed);
		}
		$(this).closest(".spotify-wrap").toggleClass("open");
	});

	// var heroVideo = $('.hero-video');

	// if(heroVideo.length !== 0) {
	// 	if($(window).innerWidth() >= 768) {
	// 		if (heroVideo.attr("data-hi-res").length != 0){
	// 			var  video = heroVideo.attr("data-hi-res").replace(/\.[^/.]+$/, "")
	// 		} else {
	// 			// show image holder
	// 			console.log('show desktop image holder');
	// 		}
	// 	} else {
	// 		if(heroVideo.attr("data-low-res").length != 0){
	// 			var  video = heroVideo.attr("data-low-res").replace(/\.[^/.]+$/, "")
	// 		}else{
	// 			var  video = heroVideo.attr("data-hi-res").replace(/\.[^/.]+$/, "")
	// 		}
	// 	}
	// 	heroVideo.empty();
	// 		heroVideo
	// 				.append('<source src="' + video + '.mp4" type="video/mp4" >')
	// 				.append('<source src="' + video + '.webm" type="video/webm" >')
	// 				.append('<source src="' + video + '.ogv" type="video/ogv" >');
	// }

	// quote slider
	// var quoteSlider = $(".quote-slider");
	// if (quoteSlider.length > 0) {
	// 	quoteSlider.slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		infinite: true,
	// 		dots: true,
	// 		arrows: false,
	// 		adaptiveHeight: true,
	// 		autoplay: true,
	// 	});
	// }

	// // quote slider Hero Media Block
	// var heroSlider = $(".hero-slider");
	// if (heroSlider.length > 0) {
	// 	heroSlider.slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		infinite: true,
	// 		dots: false,
	// 		arrows: false,
	// 		adaptiveHeight: true,
	// 		autoplay: true,
	// 	});
	// }

	// nav blur only when scroll
	var sectionHeader = $(".home section.header");
	// var bookBtn = $('.btn-mobile');
	if (sectionHeader.length != 0) {
		$(window).scroll(function () {
			var pos = $(window).scrollTop();
			if (pos > 0) {
				sectionHeader.addClass("blur");
				// bookBtn.addClass('position-fixed')
			} else {
				sectionHeader.removeClass("blur");
				// bookBtn.removeClass('position-fixed')
			}
		});
	}
});